import { ProjectReviewSummary } from '../types/project';
import { Reviewer } from '../types/review';

const REVIEWER_LABEL = 'reviewer';
const APPROVER_LABEL = 'approver';
const NO_APPROVERS_LABEL = 'no approvers';
const NOT_SUBMITTED_REVIEW_SUMMARY = 'Not yet submitted for review';

export interface ReviewParticipantCounts {
  reviewerCount: number;
  approverCount: number;
}

const formatRoleCount = (count: number, label: string): string =>
  `${count} ${label}${count === 1 ? '' : 's'}`;

export const formatParticipantSummary = ({
  reviewerCount,
  approverCount,
}: ReviewParticipantCounts): string => {
  const reviewerSummary = formatRoleCount(reviewerCount, REVIEWER_LABEL);
  const approverSummary =
    approverCount === 0
      ? NO_APPROVERS_LABEL
      : formatRoleCount(approverCount, APPROVER_LABEL);

  return `${reviewerSummary}, ${approverSummary}`;
};

export const getReviewParticipantCounts = (
  reviewers: Reviewer[],
): ReviewParticipantCounts => {
  const activeReviewers = reviewers.filter((reviewer) => !reviewer.is_owner);

  return {
    reviewerCount: activeReviewers.filter(
      (reviewer) => reviewer.role === REVIEWER_LABEL,
    ).length,
    approverCount: activeReviewers.filter(
      (reviewer) => reviewer.role === APPROVER_LABEL,
    ).length,
  };
};

export const getProjectReviewParticipantSummary = (
  reviewSummary: ProjectReviewSummary,
): string => {
  if (reviewSummary.status === 'not_submitted') {
    return NOT_SUBMITTED_REVIEW_SUMMARY;
  }

  return formatParticipantSummary({
    reviewerCount: reviewSummary.reviewer_count,
    approverCount: reviewSummary.approver_count,
  });
};